<script>
import MottoIcon from './motto-icon.vue'

export default {
  components: { MottoIcon },
  props: {
    theme: {
      type: String,
      default: 'gray',
    },
    icon: {
      type: String,
      default: 'Info',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.infoBlockGray]: theme === 'gray',
      [$style.infoBlockWarning]: theme === 'warning',
      [$style.infoBlock]: true,
    }">
    <MottoIcon v-if="!hideIcon" :class="$style.infoLogo" name="Info" icon-color="darkGray"></MottoIcon>
    <p :class="$style.infoText" class="p2">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.infoBlock {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
}

.infoBlockGray {
  background: $lightest-gray;
}

.infoBlockWarning {
  background: $secondary-orange;
}

.infoLogo {
  @media (max-width: $lg-breakpoint) {
    display: none;
  }

  margin-right: 16px;
}

.infoText {
  margin: auto 0;
}
</style>
